import Bugsnag, { BrowserConfig } from '@bugsnag/js';
import BugsnagPluginVue from '@bugsnag/plugin-vue';
import { App } from 'vue';
import getReleaseStage from '#server/shared/get-release-stage';
import * as packageJson from '../../package.json';

const { version } = packageJson;

export interface BugsnagInit {
  app: App;
  executionContext?: string;
}

/**
 * The idea here was to be able to initialize bugsnag in multiple contexts,
 * e.g. the ui thread and our various workers, but bugsnag doesn't work in
 * workers yet, so this code could be simpler. They say it is on the roadmap,
 * though, so I'll leave it
 */
export function init({ app, executionContext }: BugsnagInit) {
  const config: BrowserConfig = {
    apiKey: process.env.BUGSNAG_API_KEY,
    releaseStage: getReleaseStage(getHost()),
    appVersion: version,
    redactedKeys: [
      'password',
      'newPassword',
      'currentPassword',
      'credit_card_token',
      'authorization',
      'accessToken',
      'apiKey',
    ],
    plugins: [new BugsnagPluginVue()],
  };

  if (executionContext) {
    config.appType = executionContext;
  }

  Bugsnag.start(config);

  const plugin = Bugsnag.getPlugin('vue');
  if (plugin) {
    app.use(plugin);
  }
}

export function getHost() {
  const global = typeof window !== 'undefined' ? window : self;
  const { host } = global.location;
  return host;
}
